var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{shadow: _vm.shadow},attrs:{"draggable":"false","src":_vm.actualSrc,"alt":"Calendar photo"}})}
var staticRenderFns = []

export { render, staticRenderFns }